export default __webpack_public_path__ + "static/media/probing_attack.cc1eb1e2.png";